const GlSpacer = () => <div className="flex flex-auto" />

export default GlSpacer
